import { GATE_STYLES } from '@/components/assistant-ui/approval/gate-styles';
import { loadToolkitGates, type ToolkitGate } from '@/components/assistant-ui/hitl/hitl-provider';
import { isToolIconObject, type ToolIconConfig } from '@/lib/constants/tool-ui-icons';

import type { LucideIcon } from 'lucide-react';

export interface GatedAction extends ToolkitGate {
  icon: LucideIcon;
}

export function actionIcon(config: ToolIconConfig | undefined): LucideIcon {
  if (!config) return GATE_STYLES.action.icon;
  return isToolIconObject(config) ? config.icon : config;
}

/** Each action carries the first icon its trail row shows in the chat, or the generic one. */
export async function loadGatedActions({
  hitlToolkitIds,
  toolGroupIds,
  locale,
}: {
  hitlToolkitIds: number[];
  toolGroupIds: number[];
  locale: string;
}): Promise<GatedAction[]> {
  const [toolkitGates, getTrailConfig] = await Promise.all([
    loadToolkitGates({ ids: hitlToolkitIds, locale }),
    // Imported on demand: the tool groups carry the chat runtime, which this entry stays free of.
    import('@/components/assistant-ui/tool-group-provider').then(({ loadTrailConfig }) =>
      loadTrailConfig(toolGroupIds),
    ),
  ]);
  return toolkitGates.map(gate => ({
    ...gate,
    icon: actionIcon(getTrailConfig?.(gate.toolName)?.icons?.[0]),
  }));
}
